import React, { useState, useEffect } from "react";
import "./SubCategories.css"
import axiosConfig from "../../Service/axiosConfig"
import { useNavigate, NavLink, useParams, useLocation } from "react-router-dom";

const SubCategories = (props) => {
    const { category_id, promo_id, category_slug, subcategory_id, brand_id, is_promotionals } = props;
    console.log(category_id, "'ooooooooooooooo")
    console.log(subcategory_id, "'ooooooooooooo22")
    console.log(props, "ppppppppppalso")
    const [loading, setLoading] = useState(false)
    const [Data, SetData] = useState([])
    const Navigate = useNavigate()
    const [isMobile, setIsMobile] = useState(window.innerWidth < 1020);
    const { friendlyurl } = useParams();
    const handleResize = () => {
        setIsMobile(window.innerWidth < 1020);
    };

    const HandleNavigate = (path) => {
        Navigate(path, { state: { category_id, category_slug, subcategory_id, brand_id } })
    }

    // const GetData = async (category_id) => {
    //     setLoading(true);
    //     try {

    //         if (brand_id) {
    //             const response = await axiosConfig.get(
    //                 `/catlog/brandfilter/?brand_id=${brand_id}`
    //             );
    //             SetData(response.data);
    //         }

    //         else if (promo_id) {
    //             const response = await axiosConfig.get(
    //                 `/catlog/promotional/${promo_id}/items/?category=${category_id}`
    //             );
    //             SetData(response?.data?.results);
    //         }

    //         else if (category_id) {
    //             // ✅ NORMAL CATEGORY FLOW (THIS WAS MISSING)
    //             const response = await axiosConfig.get(
    //                 `/catlog/sub-categories/?category=${category_id}&is_suspended=false&page_size=100`
    //             );
    //             SetData(response.data.results);
    //         }

    //     } catch (error) {
    //         console.log(error);
    //     } finally {
    //         setLoading(false);
    //     }
    // };
    // In SubCategories.js - Update the GetData function
    const GetData = async (category_id) => {
        setLoading(true);
        try {
            if (brand_id) {
                const response = await axiosConfig.get(
                    `/catlog/brandfilter/?brand_id=${brand_id}`
                );
                SetData(response.data);
            }
            else if (promo_id) {
                // Get the REAL category ID from promotional_data
                let realCategoryId = category_id;

                // If promotional_data exists, get the first category ID from it
                if (props.promotional_data?.category?.length > 0) {
                    realCategoryId = props.promotional_data.category[0].id; // This will be 1, 6, or 7
                    console.log("Using real category ID from promotional_data:", realCategoryId);
                }

                // Make API call with the REAL category ID
                const response = await axiosConfig.get(
                    `/catlog/promotional/${promo_id}/items/?category=${realCategoryId}`
                );
                SetData(response?.data?.results || []);
            }
            else if (category_id) {
                const response = await axiosConfig.get(
                    `/catlog/sub-categories/?category=${category_id}&is_suspended=false&page_size=100`
                );
                SetData(response.data.results);
            }
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        GetData(category_id);
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener("resize", handleResize);
        }
    }, [category_id, promo_id])
    console.log(Data, "also data")
    return (
        <>{
            isMobile ?
                <div className="categories-container">
                    {loading ? (
                        <div className="loader-container">
                            <img src={require('../images/loader.gif')} alt="Loading..." />
                        </div>
                    ) : (
                        <>
                            {
                                Data.map((itemObj, index) => {
                                    console.log(itemObj, "lllllllllll")
                                    return (
                                        <div className={`subcat-item-container ${itemObj.slug === friendlyurl ? 'active' : ''}`} key={index} onClick={() =>
                                            Navigate(
                                                is_promotionals
                                                    ? `/${itemObj.slug}`           // For promotional: just subcategory slug
                                                    : `/${category_slug}/${itemObj.slug}`, // For normal: category/subcategory
                                                {
                                                    state: {
                                                        category_id,
                                                        subcategory_id: itemObj.id,
                                                        ...(is_promotionals && {
                                                            promo_id,
                                                            is_promotional: true,
                                                            category_id: category_id  // Keep the category_id
                                                        })
                                                    }
                                                }
                                            )
                                        }
                                        >
                                            {/* <NavLink to={`/${category_slug}/${itemObj.slug}`} > */}
                                            <div className="text-center ismobile-relclass relclass">
                                                <img src={itemObj.image && itemObj.image.image} />
                                                <p className="sub-p">{itemObj.name}</p>
                                            </div>
                                            {/* </NavLink> */}
                                        </div>
                                    )
                                })
                            }
                        </>
                    )}
                </div> :

                <div className="categories-container">
                    {loading ? (
                        <div className="loader-container">
                            <img src={require('../images/loader.gif')} alt="Loading..." />
                        </div>
                    ) : (
                        <>
                            {
                                Data.map((itemObj, index) => {
                                    return (
                                        <div className={`subcat-item-container ${itemObj.slug === friendlyurl ? 'active' : ''}`} key={index} onClick={() =>
                                            Navigate(
                                                is_promotionals
                                                    ? `/${itemObj.slug}`           // For promotional: just subcategory slug
                                                    : `/${category_slug}/${itemObj.slug}`, // For normal: category/subcategory
                                                {
                                                    state: {
                                                        category_id,
                                                        subcategory_id: itemObj.id,
                                                        ...(is_promotionals && {
                                                            promo_id,
                                                            is_promotional: true,
                                                            category_id: category_id  // Keep the category_id
                                                        })
                                                    }
                                                }
                                            )
                                        }>
                                            {console.log(itemObj.slug, "item_slug")}
                                            {console.log(category_slug, "category_slug")}
                                            {/* <NavLink to={`/${category_slug}/${itemObj.slug}`} > */}
                                            <div className="row align-items-center">
                                                <div className="col-3">
                                                    <img src={itemObj.image && itemObj.image.image} />
                                                </div>
                                                <div className="col-9 sub-p-container">
                                                    <p className="sub-p">{itemObj.name}</p>
                                                </div>
                                            </div>
                                            {/* </NavLink> */}
                                        </div>
                                    )
                                })
                            }
                        </>
                    )}
                </div>
        }
        </>
    )
}
export { SubCategories };